// Model.js
// -----------------------
// @module Case
define('PartiesEvents.Model', [
    'Backbone',
    'Utils',
    'underscore',
    'jQuery'
], function PartiesEventsModel(
    Backbone,
    Utils,
    _,
    $
) {
    'use strict';

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        // @property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath('services/PartiesEvents.Service.ss')
        ),
        validation: {
            firstname: {
                required: true,
                msg: _('First name is required').translate()
            },
            lastname: {
                required: true,
                msg: _('Last name is required').translate()
            },
            email: {
                required: true,
                pattern: 'email',
                msg: _('Please provide a valid email').translate()
            },
            custevent_aws_billing_adress: {
                required: true,
                msg: _('Billing address is required').translate()
            },
            city: {
                required: true,
                msg: _('City address is required').translate()
            },
            state: {
                required: true,
                msg: _('State address is required').translate()
            },
            zipcode: {
                required: true,
                msg: _('Zipcode address is required').translate()
            },
            phone: {
                required: true,
                msg: _('Phone number is required').translate()
            }
        },
        hasSpiritSelected: function hasSpiritSelected() {
            return this.getSelectedSpirits().length > 0;
        },
        getSelectedSpirits: function getSelectedSpirits() {
            var selectedSpirits = [];

            if ($('#whisky_checkbox').is(':checked')) {
                selectedSpirits.push('1');
            }
            if ($('#vodka_checkbox').is(':checked')) {
                selectedSpirits.push('2');
            }
            if ($('#tequila_checkbox').is(':checked')) {
                selectedSpirits.push('3');
            }
            if ($('#rum_checkbox').is(':checked')) {
                selectedSpirits.push('4');
            }
            if ($('#gin_checkbox').is(':checked')) {
                selectedSpirits.push('5');
            }
            if ($('#other_spirit_checkbox_checkbox').is(':checked')) {
                selectedSpirits.push('6');
            }

            return selectedSpirits;
        },
        getSelectedWines: function getSelectedWines() {
            var selectedWines = [];

            if ($('#red_checkbox').is(':checked')) {
                selectedWines.push('1');
            }
            if ($('#cabernet_sauvignon_checkbox').is(':checked')) {
                selectedWines.push('2');
            }
            if ($('#pinot_noir_checkbox').is(':checked')) {
                selectedWines.push('3');
            }
            if ($('#white_checkbox').is(':checked')) {
                selectedWines.push('4');
            }
            if ($('#chardonnay_checkbox').is(':checked')) {
                selectedWines.push('5');
            }
            if ($('#pinot_grigio_checkbox').is(':checked')) {
                selectedWines.push('6');
            }

            return selectedWines;
        },
        getSelectedBeers: function getSelectedBeers() {
            var selectedBeers = [];

            if ($('#domestic_checkbox').is(':checked')) {
                selectedBeers.push('1');
            }
            if ($('#draft_checkbox').is(':checked')) {
                selectedBeers.push('2');
            }
            if ($('#bottles_checkbox').is(':checked')) {
                selectedBeers.push('3');
            }
            if ($('#cans_checkbox').is(':checked')) {
                selectedBeers.push('4');
            }
            if ($('#keg_checkbox').is(':checked')) {
                selectedBeers.push('5');
            }

            return selectedBeers;
        },
        formatDate: function formatDate(date) {
            var correctDate = {};
            if (date && date.indexOf('-') !== -1) {
                correctDate.day = date.split('-')[2];
                correctDate.month = date.split('-')[1];
                correctDate.year = date.split('-')[0];
                return (
                    correctDate.month + '/' + correctDate.day + '/' + correctDate.year
                );
            }
            return date;
        },
        toJSON: function toJSON() {
            var attrs = _.clone(this.attributes);

            // var fullBar = $('#custevent_aws_full_bar').is(':checked') ? 'T' : 'F';
            // var selectedSpirits = this.getSelectedSpirits();
            // var selectedBeers = this.getSelectedBeers();
            // var selectedWines = this.getSelectedWines();
            // var needChampagne = $('#custevent_aws_champagne').is(':checked') ? 'T' : 'F';
            // var needProsecco = $('#custevent_aws_prosecco').is(':checked') ? 'T' : 'F';

            /* 05. full bar
            attrs.custevent_aws_full_bar = fullBar;

            // 06. served spirits management
            attrs.custevent_aws_served_spirits = selectedSpirits;

            // 08. selected beer management
            attrs.custevent_aws_beer_type = selectedBeers;

            // 10. selected wines management
            attrs.custevent_aws_wine_types = selectedWines;

            // 11. champagne
            attrs.custevent_aws_champagne = needChampagne;

            // 11. champagne
            attrs.custevent_aws_prosecco = needProsecco;

            attrs.incomingmessage = '';

            /*if (attrs.custevent_aws_delivery_date === '') {
                delete attrs.custevent_aws_delivery_date;
            } else {
                attrs.custevent_aws_delivery_date = this.formatDate(
                    attrs.custevent_aws_delivery_date
                );
            }*/

            attrs.custevent_aws_event_date = this.formatDate(
                attrs.custevent_aws_event_date
            );

            return attrs;
        }
    });
});
